import { useRiderPayrollEstimate } from "@/hooks/use-rider-payroll-estimate";
import { formatCurrency } from "@/lib/utils";

import type { PayrollAdjustmentFormValues } from "./rider-payroll-schema";

export function RiderPayrollLiveSummary({
  riderId,
  riderSaleIds,
  adjustments,
}: {
  riderId: string;
  riderSaleIds: string[];
  adjustments: PayrollAdjustmentFormValues[];
}) {
  const {
    daysWorked,
    dailyWageTotal,
    salesIncomeAmount,
    bonusAmount,
    grossBeforeAdjustments,
  } = useRiderPayrollEstimate(riderId, riderSaleIds);

  const incomeAdjustments = adjustments
    .filter((a) => a.type === "income")
    .reduce((sum, a) => sum + (a.amount || 0), 0);
  const deductions = adjustments
    .filter((a) => a.type === "deduction")
    .reduce((sum, a) => sum + (a.amount || 0), 0);
  const netAmount = Math.max(
    0,
    grossBeforeAdjustments + incomeAdjustments - deductions,
  );

  if (!riderId) return null;

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2.5 rounded-lg border bg-muted/20 p-3 sm:grid-cols-4">
        <div>
          <p className="text-xs text-muted-foreground">Hari Kerja</p>
          <p className="font-semibold text-sm">{daysWorked} hari</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Gaji Harian</p>
          <p className="font-semibold text-sm">
            {formatCurrency(dailyWageTotal)}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Pendapatan Penjualan</p>
          <p className="font-semibold text-sm">
            {formatCurrency(salesIncomeAmount)}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Bonus Target</p>
          <p className="font-semibold text-sm">{formatCurrency(bonusAmount)}</p>
        </div>
      </div>

      <div className="flex items-center justify-between rounded-lg border bg-muted/30 p-3">
        <span className="text-sm font-semibold">Gaji Bersih (estimasi)</span>
        <span className="text-base font-bold text-foreground">
          {formatCurrency(netAmount)}
        </span>
      </div>
    </div>
  );
}
